// extracted by mini-css-extract-plugin
export default {"header-small":"VisitPage_header-small__1eavW","header-caption":"VisitPage_header-caption__v9uU1"};